import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({ selector: '[mweSelectFirstInvalidInput]' })
export class SelectFirstInvalidInputDirective implements AfterViewInit {
  private el = inject(ElementRef);

  ngAfterViewInit(): void {
    const invalidEl = this.el.nativeElement.querySelector('input.ng-invalid');

    if (!invalidEl) {
      return;
    }

    invalidEl.focus();
  }
}
